<dv-grid
  [actions]="actions"
  (filtersCleared)="onFiltersCleared()"
  [alwaysShowFilterButton]="alwaysShowFilterButton">
  <dv-quick-filter [agGrid]="agGrid" [filters]="quickFilters">
  </dv-quick-filter>
  <ag-grid-angular
    class="fleet-grid"
    #agGrid
    class="ag-theme-devinco"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
    (filterChanged)="onFilterChanged($event)"
    (firstDataRendered)="onFirstDataRendered($event)"
    (rowDataUpdated)="onRowDataUpdated($event)">
  </ag-grid-angular>
</dv-grid>
